
import React from "react";
import sectionImg from "../../images/Section 03.webp";
import "../../styles/main.scss";

const challenges = [
  {
    num: 1,
    emoji: "📅",
    title: "Your salon runs every day, but your actual weekly profit still does not feel fully clear.",
    desc: (
      <>
        Money comes in, money goes out, staff stays busy — but one question remains:
        <span className="section-03__highlight-quote">"How much did I truly make this week?"</span>
        Many decisions get taken on rough assumptions instead of clear numbers.
      </>
    ),
  },
  {
    num: 2,
    emoji: "📋",
    title: "Your CA handles tax and compliance, but weekly salon clarity still remains missing.",
    desc: "Your CA plays an important role in taxation, filing, and compliance. But a simple weekly view of profit and pressure areas is still missing.",
  },
  {
    num: 3,
    emoji: "🧾",
    title: "You have numbers in many places, but very little of it turns into useful salon insight.",
    desc: "Billing, expenses, UPI, POS — data exists but stays scattered. Without one weekly view, it is hard to know what is working and what needs attention.",
  },
  {
    num: 4,
    emoji: "📈",
    title: "It is hard to know what today's salon numbers really mean for next week or next month.",
    desc: "A busy salon is not always a growing one. Without weekly clarity, it becomes difficult to see if you are getting stronger or simply repeating the same pattern.",
  },
  {
    num: 5,
    emoji: "₹",
    title: "Small leaks and unnoticed costs quietly reduce your salon's real profit.",
    desc: (
      <>
        Discounting, wastage, unplanned buying, and silent overhead may each look small on their own.
        <span className="section-03__highlight-quote section-03__highlight-quote--danger">
          By the time the impact becomes visible, the week — or even the month — may already be gone.
        </span>
      </>
    ),
  },
];

const overlayPoints = [
  { icon: "📅", text: "Your salon runs every day, but weekly profit is unclear." },
  { icon: "📋", text: "Your CA handles tax and compliance, but weekly clarity is missing." },
  { icon: "🧾", text: "Numbers exist in many places, but insights are hard to find." },
  { icon: "📈", text: "Hard to know what today's numbers mean for next week or month." },
  { icon: "₹", text: "Small leaks and unnoticed costs quietly reduce real profit." },
];

const Section03 = () => {
  return (
    <section className="section-03">
      <div className="section-03__top-row">
        <div className="section-03__content">
          {/* <div className="section-03__badge">SECTION 03</div> */}
          <h2 className="section-03__title">
            The Real Profit Challenges Many Salon Owners{" "}
            <span className="section-03__title--highlight">Silently Face.</span>
          </h2>
          <p className="section-03__desc">
            Even when a salon looks busy and active from the outside, the owner
            may still not feel fully clear about what the business is actually
            leaving behind.
          </p>
          <p className="section-03__desc section-03__desc--emphasis">
            Munafa Engine is designed to bring this{" "}
            <span className="section-03__desc--highlight">weekly clarity</span>{" "}
            into view.
          </p>
        </div>

        <div className="section-03__image-overlay-wrapper">
          <img
            src={sectionImg}
            alt="Munafa Engine dashboard preview showing salon clarity"
            className="section-03__image"
            loading="lazy"
            decoding="async"
          />
          {/* <div className="section-03__overlay-box">
            {overlayPoints.map((point, idx) => (
              <div className="section-03__overlay-point" key={idx}>
                <span className="section-03__overlay-icon">{point.icon}</span>
                <span>{point.text}</span>
              </div>
            ))}
          </div> */}
        </div>
      </div>

      <div className="section-03__divider-row">
        <span className="section-03__divider-title">
          FIVE CHALLENGES SILENTLY REDUCING YOUR SALON'S{" "}
          <span className="section-03__divider-highlight">REAL PROFIT</span>
        </span>
      </div>

      <div className="section-03__challenges-row">
        {challenges.map((challenge) => (
          <div className="section-03__challenge-card" key={challenge.num}>
            <div className={`section-03__challenge-num section-03__challenge-num--${challenge.num}`}>
              {challenge.num}
            </div>
            <div className="section-03__challenge-icon-emoji">{challenge.emoji}</div>
            <div className="section-03__challenge-title">{challenge.title}</div>
            <div className="section-03__challenge-desc">{challenge.desc}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Section03;
